(function ($){


	$('.nav-item').on('click', function(){

		if($(this).hasClass('active')){
			$('.nav-item').removeClass('active');
		} else {
			$('.nav-item').removeClass('active');
			$(this).addClass('active')
		}

	});

    // Reviews slider
    // $('.reviewsslider').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   dots: true,
    //   arrows: false,
    //   fade:true,
    //   speed:2000,
    //   autoplaySpeed: 3000
    // });
  

})(jQuery);

jQuery(document).ready(function(){
    const owlSlider = jQuery('#home-logo-slider');
    
      owlSlider.owlCarousel({
      loop:true,
      margin:10,
      nav:false,
      dots:true,
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsive:{
          0:{
              items:2
          },
          600:{
              items:4
          },
          1000:{
              items:5
          }
      }
    });

    const logoHome = jQuery('#logo-carousel');

    logoHome.owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:3,
            dots:true,
        },
        600:{
            items:4
        },
        1000:{
            items:5
        }
    }
  });

   const customer = jQuery('#customer-carousel');

    customer.owlCarousel({
      loop:true,
      margin:20,
      nav:true,
      dots:false,
      autoplay:false,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      navText:['<i class="iconify" data-icon="mynaui:arrow-long-left">','<i class="iconify" data-icon="mynaui:arrow-long-right">'],
      responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:3
          }
      }
    });

    const logoBuy = jQuery('#logo-buy');
  
      logoBuy.owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        dots:false,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        navText:['<i class="iconify" data-icon="mynaui:arrow-long-left">','<i class="iconify" data-icon="mynaui:arrow-long-right">'],
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
      });


    const beforeAfter = jQuery('#before-after');
  
      beforeAfter.owlCarousel({
        loop:false,
        margin:20,
        nav:true,
        dots:false,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        navText:['<i class="iconify" data-icon="mynaui:arrow-long-left">','<i class="iconify" data-icon="mynaui:arrow-long-right">'],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
      });

  const videoSlider = jQuery('#testimonial-video-slider');
  
      videoSlider.owlCarousel({
        loop:false,
        margin:20,
        nav:true,
        dots:false,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        navText:['<i class="iconify" data-icon="mynaui:arrow-long-left">','<i class="iconify" data-icon="mynaui:arrow-long-right">'],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
      });

  

  jQuery(window).scroll(function() {    
      var scroll = jQuery(window).scrollTop();
  
       //>=, not <=
      if (scroll >= 150) {
          //clearHeader, not clearheader - caps H
          jQuery("body").addClass("header-sticky");
      } else {
        jQuery("body").removeClass("header-sticky");
      }
  }); //missing );

  jQuery('.title-link').insertBefore('.product-form__quantity ');

  jQuery('#Shop .title-link').insertBefore('#Shop .price-block ');
  jQuery('.product-content.content-2 .title-link').insertBefore('.product-content.content-2 .price-block ');

    //magnificPopup
    jQuery('.popup-video').magnificPopup({
      type: 'iframe'
    });

    jQuery('.before-after-col').magnificPopup({
      delegate: 'a',
      type:'image',
      gallery: {
          enabled:true
        }
    });

  jQuery('.before-after-section').insertBefore('.tab-customize-wrapper');
    
  
});



